import { render } from "./HomeCollection.vue?vue&type=template&id=300c53f2"
import script from "./HomeCollection.vue?vue&type=script&lang=js"
export * from "./HomeCollection.vue?vue&type=script&lang=js"

import "./HomeCollection.vue?vue&type=style&index=0&id=300c53f2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__